/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} New_Project_Confirm_TextInputs */

const en_new_project_confirm_text = /** @type {(inputs: New_Project_Confirm_TextInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Creating a new project will clear the current project. Are you sure you want to continue?`)
};

const fr_new_project_confirm_text = /** @type {(inputs: New_Project_Confirm_TextInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`La creation d'un nouveau projet effacera le projet actuel. Voulez-vous continuer ?`)
};

const de_new_project_confirm_text = /** @type {(inputs: New_Project_Confirm_TextInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Wenn Sie ein neues Projekt erstellen, wird das aktuelle Projekt gelöscht. Möchten Sie wirklich fortfahren?`)
};

const it_new_project_confirm_text = /** @type {(inputs: New_Project_Confirm_TextInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`La creazione di un nuovo progetto cancellerà il progetto corrente. Vuoi continuare?`)
};

const ru_new_project_confirm_text = /** @type {(inputs: New_Project_Confirm_TextInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Создание нового проекта очистит текущий проект. Вы уверены, что хотите продолжить?`)
};

const es_new_project_confirm_text = /** @type {(inputs: New_Project_Confirm_TextInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Al crear un nuevo proyecto, se borrará el proyecto actual. ¿Seguro que desea continuar?`)
};

const zh_cn2_new_project_confirm_text = /** @type {(inputs: New_Project_Confirm_TextInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`创建新项目将会清除当前项目。您确定要继续吗？`)
};

const ja_new_project_confirm_text = /** @type {(inputs: New_Project_Confirm_TextInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`新しいプロジェクトを作成すると、現在のプロジェクトがクリアされます。続行してもよろしいですか?`)
};

const hi_new_project_confirm_text = /** @type {(inputs: New_Project_Confirm_TextInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`नया प्रोजेक्ट बनाने से मौजूदा प्रोजेक्ट हट जाएगा। क्या आप वाकई जारी रखना चाहते हैं?`)
};

const pt_pt2_new_project_confirm_text = /** @type {(inputs: New_Project_Confirm_TextInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Criar um novo projeto irá limpar o projeto atual. Tem certeza de que deseja continuar?`)
};

/**
* | output |
* | --- |
* | "Creating a new project will clear the current project. Are you sure you want to continue?" |
*
* @param {New_Project_Confirm_TextInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const new_project_confirm_text = /** @type {((inputs?: New_Project_Confirm_TextInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<New_Project_Confirm_TextInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_new_project_confirm_text(inputs)
	if (locale === "de") return de_new_project_confirm_text(inputs)
	if (locale === "it") return it_new_project_confirm_text(inputs)
	if (locale === "ru") return ru_new_project_confirm_text(inputs)
	if (locale === "es") return es_new_project_confirm_text(inputs)
	if (locale === "zh-CN") return zh_cn2_new_project_confirm_text(inputs)
	if (locale === "ja") return ja_new_project_confirm_text(inputs)
	if (locale === "hi") return hi_new_project_confirm_text(inputs)
	if (locale === "pt-PT") return pt_pt2_new_project_confirm_text(inputs)
	return en_new_project_confirm_text(inputs)
});